import { Component, OnInit, OnDestroy } from '@angular/core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { ReportsService } from 'src/app/shared/services/reports.service';
import { Filter } from 'src/app/shared/models/filter.model';
import { Observable, Subscription } from 'rxjs';
import { Lookup } from 'src/app/shared/models/admin-models/lookup.model';
import { UserService } from 'src/app/shared/services/admin-services/user.service';
import { BranchOfficeService } from 'src/app/shared/services/admin-services/branch-office.service';
import { RoleSendService } from 'src/app/shared/services/role-send.service';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-meeting-report',
  templateUrl: './meeting-report.component.html',
  styleUrls: ['./meeting-report.component.sass']
})
export class MeetingReportComponent implements OnInit, OnDestroy {
  faSearch = faSearch;
  faCalendarAlt = faCalendarAlt;

  roleService: Subscription;
  roleType: String = '';

  filter: Filter = new Filter({ Filter: {} })

  reports;
  page = 1;
  pageSize = 10;
  total;

  filterDate = new Date();
  filterForm = new FormGroup({
    dateFrom: new FormControl(''),
    dateTo: new FormControl(''),
    settlement: new FormControl(''),
    appointmentSource: new FormControl(''),
    agentCode: new FormControl(''),
    userID: new FormControl(''),
    agency: new FormControl(''),
    branchOfficeID: new FormControl('')
  })

  constructor(private reportsService: ReportsService, private branchOfficeService: BranchOfficeService, private userService: UserService, private roleSendService: RoleSendService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )
  }

  ngOnInit() {
    this.filterDate.setMonth(this.filterDate.getMonth() + 1);
    this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
    this.filterForm.get('dateTo').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })

    this.getAllBranchOffices()
    this.getBoxViewUsers()

    this.getReports();
  }

  ngOnDestroy() {
    this.roleService.unsubscribe()
  }

  getReports() {
    this.filter.data.Filter = { DateScheduledFrom: this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00", DateScheduledTo: this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00" };

    if (this.filterForm.value.branchOfficeID)
      this.filter.data.Filter.BranchOfficeAppointmentID = this.filterForm.value.branchOfficeID
    if (this.filterForm.value.userID)
      this.filter.data.Filter.UserID = this.filterForm.value.userID
    if (this.filterForm.value.agentCode)
      this.filter.data.Filter.AgentCode = this.filterForm.value.agentCode
    if (this.filterForm.value.settlement)
      this.filter.data.Filter.Settlement = this.filterForm.value.settlement
    if (this.filterForm.value.appointmentSource)
      this.filter.data.Filter.AppointmentSource = this.filterForm.value.appointmentSource
    if (this.filterForm.value.agency == '1')
      this.filter.data.Filter.Agency = true
    if (this.filterForm.value.agency == '0')
      this.filter.data.Filter.Agency = false

    // this.reports = this.reportsService.appointmentReport(this.filter)
    this.reportsService.appointmentReport(this.filter)
      .subscribe(
        x => {
          // console.log(x)
          this.reports = x;
          this.total = x.length;
        }
      )
  }

  exportExcelReport() {
    this.filter.data.Filter = { DateScheduledFrom: this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00", DateScheduledTo: this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00" };

    if (this.filterForm.value.branchOfficeID)
      this.filter.data.Filter.BranchOfficeAppointmentID = this.filterForm.value.branchOfficeID
    if (this.filterForm.value.userID)
      this.filter.data.Filter.UserID = this.filterForm.value.userID
    if (this.filterForm.value.agentCode)
      this.filter.data.Filter.AgentCode = this.filterForm.value.agentCode
    if (this.filterForm.value.settlement)
      this.filter.data.Filter.Settlement = this.filterForm.value.settlement
    if (this.filterForm.value.appointmentSource)
      this.filter.data.Filter.AppointmentSource = this.filterForm.value.appointmentSource
    if (this.filterForm.value.agency == '1')
      this.filter.data.Filter.Agency = true
    if (this.filterForm.value.agency == '0')
      this.filter.data.Filter.Agency = false

    this.reportsService.appointmentExcelReport(this.filter)
      .subscribe(
        (x: any) => {
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          var filename = contentDispositionHeader.split(';')[1].trim().split('=')[1].split('"')[1];
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      )
  }

  brankOfficeArray: Observable<Lookup[]>
  getAllBranchOffices() {
    this.brankOfficeArray = this.branchOfficeService.boxView();
  }

  boxUserArray: Observable<any>;
  getBoxViewUsers() {
    let fil = new Filter({ Top: null, Page: null, Filter: {}, Sort: { SortBy: 'Active', Direction: 1 } })
    if (this.filterForm.value.branchOfficeID)
      fil.data.Filter.BranchOfficeID = this.filterForm.value.branchOfficeID
    this.boxUserArray = this.userService.boxView(fil)
  }

  clearFilters() {
    this.filterForm.reset({ dateFrom: { year: this.filterForm.value.dateFrom.year, month: this.filterForm.value.dateFrom.month, day: this.filterForm.value.dateFrom.day }, dateTo: { year: this.filterForm.value.dateTo.year, month: this.filterForm.value.dateTo.month, day: this.filterForm.value.dateTo.day, branchOfficeID: '', userID: '', appointmentSource: '' } })
    this.getReports()
  }

}
